/* Neven footer + email signup: mobile accordions and the two signup forms. */
(function () {
  var SUBSCRIBE_URL = 'https://api.neveneyewear.com/api/attentive/subscribe';
  var EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  function init(root) {
    if (root.dataset.nvReady) return;
    root.dataset.nvReady = 'true';

    // Accordions: which buttons are live depends on width and on x4 (three mobile menus).
    var grpBtns = [].slice.call(root.querySelectorAll('.nv-grp > .nv-acc'));
    var colBtns = [].slice.call(root.querySelectorAll('.nv-col > .nv-acc'));

    function setLive(btns, live) {
      btns.forEach(function (b) {
        b.setAttribute('aria-disabled', String(!live));
        if (live) b.removeAttribute('tabindex');
        else b.setAttribute('tabindex', '-1');
      });
    }
    function syncMode() {
      var mobile = root.getBoundingClientRect().width <= 767;
      var three = root.classList.contains('x4');
      setLive(grpBtns, mobile && three);
      setLive(colBtns, mobile && !three);
    }
    grpBtns.concat(colBtns).forEach(function (b) {
      b.addEventListener('click', function () {
        if (b.getAttribute('aria-disabled') === 'true') return;
        b.setAttribute('aria-expanded', String(b.getAttribute('aria-expanded') !== 'true'));
      });
    });
    if ('ResizeObserver' in window) new ResizeObserver(syncMode).observe(root);
    else window.addEventListener('resize', syncMode);
    syncMode();

    // Desktop: lift the fixed chat bubble and back-to-top above the legal row while it's
    // on screen, so they never sit over the legal links (CSS reads --nv-legal-lift).
    var legal = root.querySelector('.nv-legal');
    var desktop = window.matchMedia('(min-width: 769px)');
    var liftQueued = false;
    function syncLift() {
      liftQueued = false;
      var lift = 0;
      if (legal && desktop.matches) lift = Math.max(0, Math.round(window.innerHeight - legal.getBoundingClientRect().top));
      document.documentElement.style.setProperty('--nv-legal-lift', lift + 'px');
    }
    function queueLift() {
      if (liftQueued) return;
      liftQueued = true;
      requestAnimationFrame(syncLift);
    }
    window.addEventListener('scroll', queueLift, { passive: true });
    window.addEventListener('resize', queueLift);
    syncLift();

    // Signup: same endpoint the old subscribe-form section posted to.
    root.querySelectorAll('.nv-signup').forEach(function (block) {
      var form = block.querySelector('form');
      if (!form) return;
      var input = form.querySelector('input[type=email]');
      var btn = form.querySelector('button');
      var msg = block.querySelector('.nv-form__msg');

      function showError(text) {
        msg.dataset.state = 'error';
        msg.textContent = text;
      }

      input.addEventListener('input', function () {
        msg.textContent = '';
        msg.removeAttribute('data-state');
        input.removeAttribute('aria-invalid');
      });

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var email = input.value.trim();
        if (!EMAIL.test(email)) {
          showError('Enter a valid email address.');
          input.setAttribute('aria-invalid', 'true');
          input.focus();
          return;
        }

        var label = btn.innerHTML;
        btn.disabled = true;
        if (!btn.querySelector('svg')) btn.textContent = 'Signing up…';

        fetch(SUBSCRIBE_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ email: email, device: 'desktop' })
        })
          .then(function (r) { return r.json(); })
          .then(function (res) {
            if (res && res.success) block.dataset.done = 'true';
            else showError((res && res.message) || 'Something went wrong. Try again in a moment.');
          })
          .catch(function () {
            showError('Something went wrong. Try again in a moment.');
          })
          .then(function () {
            btn.disabled = false;
            btn.innerHTML = label;
          });
      });
    });
  }

  function initAll() {
    document.querySelectorAll('.nv[data-nv-footer]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
